import styled, { css } from 'styled-components'
import { InputProps } from '@elamajs/ui-kit'

import theme from '../theme'

export const Container = styled.div`
  div[class*='InputTextstyled__IconLeft'] {
    padding-left: 20px;
  }

  span[class^='ErrorMessagestyled__ErrorMessage'] {
    color: ${theme.palette.lobster(60)};
  }
`

export const Input = styled.input<InputProps>`
  height: 50px;
  border: 1px solid ${theme.palette.black(80)};
  border-radius: 5px;

  font-size: 14px;
  line-height: 20px;
  color: ${theme.palette.black(20)};

  &:placeholder {
    color: ${theme.palette.black(70)};
  }

  &:hover {
    border: 1px solid ${theme.palette.black(80)};
    box-shadow: inset 0 0 0 1px ${theme.palette.black(80)};
  }

  &:active,
  &:focus {
    border-color: ${theme.palette.blue(60)};
    box-shadow: none;
  }

  ${({ borderless }) =>
    borderless &&
    css`
      border: none;
    `}

  ${({ hasError, errorMessage }) =>
    (hasError || errorMessage) &&
    css`
      border-color: ${theme.palette.lobster(60)};
    `}
`
